import useRestockDrafts from "./useRestockDrafts";
import secondaryComponents from "../..";
import { WarningDialog } from "../../../common";

export const RestockDraftsTable = ({
  metaDetails,
  restockDrafts = [],
  gotoPage = () => {},
}) => {
  const {
    instance,
    selectedDraftToDelete,
    setSelectedDraftToDelete,
    handleConfirmDeleteDraft,
    isDeletingDraft,
  } = useRestockDrafts({
    restockDrafts,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;
  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <h4 className="py-5 text-center">No Data Available</h4>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {restockDrafts?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      <secondaryComponents.Modal
        isActive={!!selectedDraftToDelete}
        width={550}
        closeModal={() => setSelectedDraftToDelete(null)}
      >
        <WarningDialog
          title={"Delete Draft Restock"}
          closeModal={() => setSelectedDraftToDelete(null)}
          handler={handleConfirmDeleteDraft}
          isLoading={isDeletingDraft}
        >
          <p>
            Are you sure you want to permanently delete this draft restock? This
            action cannot be undone.
          </p>
          {selectedDraftToDelete?.id && (
            <p className="mt-2">
              Restock ID:{" "}
              <span className="dark--text">{selectedDraftToDelete?.id}</span>
            </p>
          )}
          {selectedDraftToDelete?.suppliers?.[0]?.name && (
            <p>
              Supplier:{" "}
              <span className="dark--text">
                {selectedDraftToDelete?.suppliers[0]?.name}
              </span>
            </p>
          )}
        </WarningDialog>
      </secondaryComponents.Modal>
    </>
  );
};
